import React, { useState } from "react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import OutsideClickHandler from "react-outside-click-handler";
import { motion, AnimatePresence } from "framer-motion";

function TableDropdown({ options, value, onChange, placeholder = "Select an option" }) {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  return (
    <OutsideClickHandler onOutsideClick={() => setIsOpen(false)}>
      <div className="relative z-10 inline-block">
        {/* Input Box with Relative Positioning */}
        <div
          className="relative flex items-center cursor-pointer"
          onClick={() => setIsOpen(!isOpen)}
        >
          <input
            readOnly
            value={
              value
                ? options.find((opt) => opt.value === value)?.label || placeholder
                : placeholder
            }
            placeholder={placeholder}
            className="text-[14px] font-poppins h-[47px] w-[150px] !border-[#596073] rounded-[16px] hover:!border-[#A5AEBC] focus:!border-[#EAC400] pt-[12px] pl-[20px] pb-[12px] pr-[20px] bg-[#363D50] hover:text-white text-[#A5AEBC] cursor-pointer focus:ring-0 focus:outline-0 transition duration-500"
          />
          {/* Chevron Icon Positioned Outside the Input */}
          <motion.div
            animate={{ rotate: isOpen ? 180 : 0 }}
            transition={{ duration: 0.2 }}
            className="absolute right-2  transform -translate-y-1/2"
          >
            <ChevronDownIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
          </motion.div>
        </div>

        {/* Dropdown Menu */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              className="absolute top-[52px] w-[150px] rounded-[16px] overflow-auto bg-[#293043] p-2 scrollbar-hide border border-[#596073] max-h-40 z-20 shadow-lg"
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: "auto" }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.15 }}
            >
              {options.map((option) => (
                <div
                  key={option.value}
                  className={`text-[14px] font-poppins px-2 py-2.5 rounded-[12px] text-white border border-solid cursor-pointer hover:bg-[#434A5D] active:border-[#FFD74A] mb-1 last:mb-0 ${
                    value === option.value
                      ? "border-[#FFD74A] bg-[#434A5D]"
                      : "border-transparent"
                  }`}
                  onClick={() => handleSelect(option.value)}
                >
                  {option.label}
                </div>
              ))}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </OutsideClickHandler>
  );
}

export default TableDropdown;